"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInputStyles = exports.createStyles = exports.Checkbox = void 0;
var react_1 = __importStar(require("react"));
var react_2 = require("../../util/react");
var styles_1 = require("../../styles");
var Input_1 = require("../Input");
function Checkbox(props) {
    var label = props.label, indeterminate = props.indeterminate, style = props.style, inputRef = props.inputRef, rest = __rest(props, ["label", "indeterminate", "style", "inputRef"]);
    var _a = styles_1.useStyles(exports.createStyles), classes = _a.classes, css = _a.css;
    var inputClasses = styles_1.useStyles(exports.createInputStyles, classes).classes;
    var internalRef = react_1.useRef();
    react_1.useEffect(function () {
        internalRef.current.indeterminate = indeterminate;
    }, [indeterminate]);
    return (react_1.default.createElement("label", { className: css(classes.wrapper, props.disabled && classes.disabled, style) },
        react_1.default.createElement(Input_1.Input, __assign({}, rest, { inputRef: react_2.composeRefs(internalRef, inputRef), type: 'checkbox', className: inputClasses.input })),
        react_1.default.createElement("span", { className: classes.check }),
        (label || label === 0) && react_1.default.createElement("span", { className: classes.label }, label)));
}
exports.Checkbox = Checkbox;
exports.createStyles = function (theme) { return ({
    wrapper: {
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
    },
    check: {
        backgroundColor: theme.pallete.surface.main,
        border: '1px solid ' + theme.pallete.gray.c60,
        borderRadius: theme.radius.input,
        display: 'inline-block',
        height: 24,
        position: 'relative',
        transition: 'all .2s ease',
        verticalAlign: 'middle',
        width: 24,
        minWidth: 24,
    },
    label: {
        marginLeft: '0.5rem',
    },
    disabled: {
        cursor: 'not-allowed',
    },
}); };
exports.createInputStyles = function (theme, classes) {
    var _a;
    return ({
        input: (_a = {
                opacity: 0,
                marginRight: -13
            },
            _a["&:hover + ." + classes.check] = {
                borderColor: theme.pallete.gray.c50,
            },
            _a["&:checked + ." + classes.check] = {
                backgroundColor: theme.pallete.primary.main,
                borderColor: theme.pallete.primary.main,
                ':after': {
                    content: '""',
                    borderRight: '2px solid ' + theme.pallete.surface.main,
                    borderBottom: '2px solid ' + theme.pallete.surface.main,
                    position: 'absolute',
                    width: 8,
                    height: 16,
                    top: 0,
                    left: 7,
                    opacity: 1,
                    transform: 'rotate(45deg) scale(1)',
                    transition: 'opacity .2s ease',
                },
            },
            _a["&:indeterminate + ." + classes.check] = {
                backgroundColor: theme.pallete.surface.main,
                borderColor: theme.pallete.primary.main,
                ':after': {
                    content: '""',
                    borderBottom: '3px solid ' + theme.pallete.primary.main,
                    position: 'absolute',
                    top: -1,
                    left: 4,
                    width: 14,
                    height: 14,
                    opacity: 1,
                    transition: 'opacity .2s ease',
                },
            },
            _a["&:focus + ." + classes.check] = {
                boxShadow: styles_1.focusBoxShadow(theme),
            },
            _a["&:disabled + ." + classes.check] = {
                opacity: 0.4,
                cursor: 'not-allowed',
            },
            _a["&:disabled + ." + classes.check + " + ." + classes.label] = {
                color: theme.pallete.gray.c70,
                cursor: 'not-allowed',
            },
            _a),
    });
};
//# sourceMappingURL=Checkbox.js.map